import { Component, Input, OnInit } from '@angular/core';
import { IAddress } from '@models';
import { Entity } from 'breeze-client';

@Component({
  selector: 'prox-address-show-frm',
  standalone: false,
  templateUrl: './address-show-frm.component.html',
})
export class AddressShowFrmComponent implements OnInit {
  @Input() address!: IAddress;
  @Input() parent?: Entity;
  @Input() addressPath?: string;

  parentEntity!: Entity;
  isPageReady = false;

  ngOnInit(): void {
    this.parentEntity = this.parent ?? (this.address as Entity);
    this.isPageReady = true;
  }

  pathify(partialPath: string) {
    if (this.addressPath) {
      return this.addressPath + '.' + partialPath;
    } else {
      return partialPath;
    }
  }
}
